// This is psychopathy at its ultimate form
export const getPropertyChangedEventDefinition = (propertyDef, associatedPropertyDef) => {
  switch (propertyDef.property.name) {
    case 'hs_value':
    case 'hs_previous_value':
      return {
        objectTypeId: associatedPropertyDef.objectTypeId,
        property: Object.assign({}, propertyDef.property, {
          options: associatedPropertyDef.property.options,
          name: associatedPropertyDef.property.name,
          type: associatedPropertyDef.property.type,
          externalOptions: associatedPropertyDef.property.externalOptions,
          referenceType: associatedPropertyDef.property.referenceType
        })
      };
    case 'hs_updated_by_user_id':
    case 'hs_previous_updated_by_user_id':
      return Object.assign({}, propertyDef, {
        property: Object.assign({}, propertyDef.property, {
          externalOptions: true,
          referenceType: 'USER'
        })
      });
    default:
      return propertyDef;
  }
};
export const getPropertyChangedEventProperty = (propertyName, property, associatedPropertyDef) => {
  if (propertyName === 'hs_name') {
    return Object.assign({}, property, {
      value: associatedPropertyDef.property.label
    });
  }
  return property;
};